/* BYCHRISTO Theme — theme.js */
(function () {
  "use strict";
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return [].slice.call((c || document).querySelectorAll(s)); };
  var CFG = window.BYC || {};

  /* ---------------- Geldformat ---------------- */
  function money(cents) {
    var v = (cents / 100).toFixed(2);
    var f = CFG.moneyFormat || "{{amount_with_comma_separator}} €";
    var parts = v.split(".");
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    var comma = whole + "," + parts[1];
    var dot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "." + parts[1];
    return f
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, comma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, whole)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ","))
      .replace(/\{\{\s*amount\s*\}\}/g, dot);
  }

  /* ---------------- Ankündigungsleiste ---------------- */
  var tItems = $$(".ticker__item"), tI = 0;
  if (tItems.length > 1) {
    setInterval(function () {
      tItems[tI].classList.remove("is-on");
      tI = (tI + 1) % tItems.length;
      tItems[tI].classList.add("is-on");
    }, 4200);
  }

  /* ---------------- Header ---------------- */
  var head = $("[data-head]");
  if (head && document.body.classList.contains("template-index")) {
    window.addEventListener("scroll", function () {
      head.classList.toggle("is-stuck", window.scrollY > 50);
    }, { passive: true });
  }

  /* ---------------- Schubladen ---------------- */
  var veil = $("[data-veil]"), menu = $("[data-menu]"), cart = $("[data-cart]");
  function openDrawer(d) {
    if (!d) return;
    [menu, cart].forEach(function (x) {
      if (x && x !== d) { x.classList.remove("is-on"); x.setAttribute("aria-hidden", "true"); }
    });
    d.classList.add("is-on"); d.setAttribute("aria-hidden", "false");
    if (veil) veil.classList.add("is-on");
    document.body.style.overflow = "hidden";
  }
  function shutDrawers() {
    [menu, cart].forEach(function (x) {
      if (x) { x.classList.remove("is-on"); x.setAttribute("aria-hidden", "true"); }
    });
    if (veil) veil.classList.remove("is-on");
    document.body.style.overflow = "";
    var mo = $("[data-menu-open]"); if (mo) mo.setAttribute("aria-expanded", "false");
  }
  var mo = $("[data-menu-open]");
  if (mo) mo.addEventListener("click", function () { openDrawer(menu); this.setAttribute("aria-expanded", "true"); });
  var co = $("[data-cart-open]");
  if (co) co.addEventListener("click", function (e) { e.preventDefault(); openDrawer(cart); });
  $$("[data-close]").forEach(function (b) { b.addEventListener("click", shutDrawers); });
  if (veil) veil.addEventListener("click", shutDrawers);
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") shutDrawers(); });
  $$("[data-menu] a").forEach(function (a) {
    a.addEventListener("click", function (e) {
      var href = a.getAttribute("href") || "";
      var hash = href.indexOf("#") > -1 ? href.slice(href.indexOf("#")) : "";
      var target = hash.length > 1 ? document.querySelector(hash) : null;
      if (target) {
        e.preventDefault();
        shutDrawers();
        var h = document.querySelector("[data-head]");
        var offset = (h ? h.offsetHeight : 66) + 40;
        window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - offset, behavior: "smooth" });
      } else { shutDrawers(); }
    });
  });

  /* ---------------- Scroll-Reveal ---------------- */
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); }
      });
    }, { threshold: 0.1, rootMargin: "0px 0px -5% 0px" });
    $$(".rv").forEach(function (el) { io.observe(el); });

    /* Konzentrationsbalken */
    var bIo = new IntersectionObserver(function (en) {
      en.forEach(function (e) {
        if (!e.isIntersecting) return;
        $$("[data-fill]", e.target).forEach(function (f, i) {
          setTimeout(function () { f.style.height = f.dataset.fill + "%"; }, i * 200);
        });
        bIo.unobserve(e.target);
      });
    }, { threshold: 0.3 });
    $$("[data-bars]").forEach(function (b) { bIo.observe(b); });

    /* Profilbalken */
    var pIo = new IntersectionObserver(function (en) {
      en.forEach(function (e) {
        if (!e.isIntersecting) return;
        $$("[data-w]", e.target).forEach(function (el, i) {
          setTimeout(function () { el.style.width = el.dataset.w + "%"; }, i * 140);
        });
        pIo.unobserve(e.target);
      });
    }, { threshold: 0.3 });
    $$("[data-prof]").forEach(function (p) { pIo.observe(p); });
  } else {
    $$(".rv").forEach(function (el) { el.classList.add("is-in"); });
  }

  /* ---------------- Kollektionsfilter ---------------- */
  $$("[data-filter]").forEach(function (chip) {
    chip.addEventListener("click", function () {
      var group = chip.closest("[data-filter-group]") || document;
      $$("[data-filter]", group).forEach(function (c) { c.classList.remove("is-on"); });
      chip.classList.add("is-on");
      var f = chip.dataset.filter;
      $$("[data-cat]").forEach(function (card) {
        card.hidden = f !== "all" && card.dataset.cat.indexOf(f) === -1;
      });
    });
  });

  /* ---------------- Duftverlauf ---------------- */
  var PHASE = [
    { max: 1, key: "top" }, { max: 4, key: "mid" }, { max: 8, key: "heart" }, { max: 12, key: "base" }
  ];
  function parseNotes(raw) {
    // Format pro Zeile:  Notenname | Startstunde | Endstunde
    return (raw || "").split(/\r?\n/).map(function (l) {
      var p = l.split("|").map(function (x) { return x.trim(); });
      if (!p[0]) return null;
      return { n: p[0], a: Number(p[1] || 0), b: Number(p[2] || 12) };
    }).filter(Boolean);
  }
  $$("[data-dry]").forEach(function (root) {
    var R = $("[data-dry-range]", root), T = $("[data-dry-time]", root),
        L = $("[data-dry-label]", root), X = $("[data-dry-text]", root),
        N = $("[data-dry-notes]", root);
    if (!R || !N) return;
    var labels = {
      top: root.dataset.labelTop || "Kopfnote", mid: root.dataset.labelMid || "Übergang",
      heart: root.dataset.labelHeart || "Herznote", base: root.dataset.labelBase || "Basisnote"
    };
    var texts = {
      top: root.dataset.textTop || "", mid: root.dataset.textMid || "",
      heart: root.dataset.textHeart || "", base: root.dataset.textBase || ""
    };
    var current = null;

    function build(el) {
      current = el;
      if (el.dataset.acc) root.style.setProperty("--acc", el.dataset.acc);
      N.innerHTML = parseNotes(el.dataset.notes).map(function (n) {
        return '<span class="note" data-a="' + n.a + '" data-b="' + n.b + '">' + n.n + "</span>";
      }).join("");
      var vis = $("[data-dry-visual]", root);
      if (vis && el.dataset.image) vis.innerHTML = el.dataset.image;
      paint();
    }
    function paint() {
      var h = Number(R.value);
      if (T) T.textContent = h + " h";
      var ph = PHASE[PHASE.length - 1];
      for (var i = 0; i < PHASE.length; i++) { if (h <= PHASE[i].max) { ph = PHASE[i]; break; } }
      if (L) L.textContent = labels[ph.key];
      if (X) X.textContent = texts[ph.key];
      $$(".note", N).forEach(function (el) {
        el.classList.toggle("is-live", h >= Number(el.dataset.a) && h <= Number(el.dataset.b));
      });
    }
    R.addEventListener("input", paint);
    var picks = $$("[data-dry-pick]", root);
    if (picks.length) {
      picks.forEach(function (b) {
        b.addEventListener("click", function () {
          picks.forEach(function (x) { x.classList.remove("is-on"); });
          b.classList.add("is-on");
          build(b);
        });
      });
      build(picks[0]);
    } else if (N.dataset.notes !== undefined || root.dataset.notes) {
      build(root.dataset.notes !== undefined ? root : N);
    } else {
      paint();
    }
  });

  /* ---------------- Produktgalerie ---------------- */
  $$("[data-gallery]").forEach(function (g) {
    g.addEventListener("click", function (e) {
      var b = e.target.closest("[data-gal-thumb]");
      if (!b) return;
      var i = b.dataset.galThumb;
      $$("[data-gal-thumb]", g).forEach(function (x) { x.classList.remove("is-on"); });
      b.classList.add("is-on");
      $$("[data-gal-item]", g).forEach(function (item) {
        var an = item.dataset.galItem === i;
        item.classList.toggle("is-on", an);
        var v = item.querySelector("video");
        if (v) {
          if (an) {
            // Beim Umschalten sofort abspielen. Stumm, weil Browser
            // Tonwiedergabe ohne direkten Klick auf das Video blockieren.
            v.muted = true;
            v.setAttribute("playsinline", "");
            var p = v.play();
            if (p && p.catch) { p.catch(function () {}); }
          } else if (!v.paused) {
            v.pause();
          }
        }
      });
    });
  });

  /* ---------------- Variantenwahl ---------------- */
  $$("[data-product-form]").forEach(function (form) {
    var variants = [];
    try { variants = JSON.parse($("[data-variants]", form).textContent); } catch (err) {}
    var idInput = $("[data-variant-id]", form);
    var priceEl = $("[data-price]", form);
    var cmpEl = $("[data-compare]", form);
    var saveEl = $("[data-save]", form);
    var noteEl = $("[data-size-note]", form);
    var btn = $("[data-add-btn]", form);
    var dockName = $("[data-dock-name]");
    var dockPrice = $("[data-dock-price]");

    function apply(v) {
      if (!v) return;
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (cmpEl) {
        cmpEl.hidden = true;
        if (saveEl) saveEl.hidden = true;
        if (v.compare_at_price && v.compare_at_price > v.price) {
          cmpEl.hidden = false; cmpEl.textContent = money(v.compare_at_price);
          if (saveEl) {
            saveEl.hidden = false;
            saveEl.textContent = (CFG.strings && CFG.strings.save ? CFG.strings.save : "Du sparst [[amount]]")
              .replace("[[amount]]", money(v.compare_at_price - v.price));
          }
        } else { cmpEl.hidden = true; if (saveEl) saveEl.hidden = true; }
      }
      if (noteEl) noteEl.textContent = v.title;
      if (btn) {
        btn.disabled = !v.available;
        btn.textContent = v.available ? btn.dataset.labelAdd : btn.dataset.labelSoldout;
      }
      if (dockName) dockName.textContent = (form.dataset.productTitle || "") + " · " + v.title;
      if (dockPrice) dockPrice.textContent = money(v.price);
      if (history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set("variant", v.id);
        history.replaceState({}, "", u.toString());
      }
    }
    $$("[data-variant-btn]", form).forEach(function (b) {
      b.addEventListener("click", function (e) {
        e.preventDefault();
        $$("[data-variant-btn]", form).forEach(function (x) { x.classList.remove("is-on"); });
        b.classList.add("is-on");
        var v = variants.filter(function (x) { return String(x.id) === b.dataset.variantBtn; })[0];
        apply(v);
      });
    });
    var on = $("[data-variant-btn].is-on", form);
    if (on) {
      var v0 = variants.filter(function (x) { return String(x.id) === on.dataset.variantBtn; })[0];
      apply(v0);
    }

    /* Menge */
    var qv = $("[data-qty-val]", form);
    $$("[data-qty]", form).forEach(function (b) {
      b.addEventListener("click", function (e) {
        e.preventDefault();
        qv.value = Math.min(99, Math.max(1, Number(qv.value) + (b.dataset.qty === "+" ? 1 : -1)));
      });
    });

    /* Absenden per AJAX */
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var fd = new FormData(form);
      if (btn) { btn.disabled = true; btn.dataset.prev = btn.textContent; btn.textContent = "…"; }
      fetch(CFG.addUrl + ".js", { method: "POST", body: fd, headers: { Accept: "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) throw new Error(res.description || res.message);
          return refreshCart();
        })
        .then(function () { openDrawer(cart); })
        .catch(function (err) {
          var box = $("[data-form-error]", form);
          if (box) { box.textContent = err.message; box.hidden = false; }
        })
        .then(function () {
          if (btn) { btn.disabled = false; btn.textContent = btn.dataset.prev || btn.dataset.labelAdd; }
        });
    });
  });

  /* Mobile Kaufleiste */
  var dock = $("[data-dock]");
  if (dock) {
    window.addEventListener("scroll", function () {
      dock.classList.toggle("is-on", window.scrollY > 520);
    }, { passive: true });
    var dockBtn = $("[data-dock-buy]");
    if (dockBtn) dockBtn.addEventListener("click", function () {
      var f = $("[data-product-form]");
      if (f) f.dispatchEvent(new Event("submit", { cancelable: true }));
    });
  }

  /* ---------------- Warenkorb ---------------- */
  function renderCart(state) {
    var wrap = $("[data-cart-items]");
    var countEls = $$("[data-cart-count]");
    countEls.forEach(function (el) { el.textContent = state.item_count; });
    var totalEl = $("[data-cart-total]");
    if (totalEl) totalEl.textContent = money(state.total_price);

    var bar = $("[data-ship-bar]"), note = $("[data-ship-note]");
    if (bar) bar.style.width = Math.min(100, state.total_price / CFG.freeShipping * 100) + "%";
    if (note) {
      note.textContent = state.total_price >= CFG.freeShipping
        ? CFG.strings.freeReached
        : CFG.strings.freeRemaining.replace("[[amount]]", money(CFG.freeShipping - state.total_price));
    }
    if (!wrap) return;
    if (!state.items.length) {
      wrap.innerHTML = '<p style="color:var(--haze)">' + CFG.strings.empty + "</p>";
      return;
    }
    wrap.innerHTML = state.items.map(function (it, i) {
      return '<div class="cart__row">' +
        '<div><strong>' + it.product_title + "</strong><small>" + it.variant_title + " · " + it.quantity + " × " + money(it.price) + "</small></div>" +
        '<div style="text-align:right"><strong>' + money(it.final_line_price) + "</strong>" +
        '<button type="button" data-cart-remove="' + (i + 1) + '">' + CFG.strings.remove + "</button></div></div>";
    }).join("");
  }
  function refreshCart() {
    return fetch(CFG.cartUrl + ".js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (s) { renderCart(s); return s; });
  }
  document.addEventListener("click", function (e) {
    var rm = e.target.closest("[data-cart-remove]");
    if (!rm) return;
    fetch(CFG.changeUrl + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line: Number(rm.dataset.cartRemove), quantity: 0 })
    }).then(function (r) { return r.json(); }).then(renderCart);
  });
  if ($("[data-cart-items]")) refreshCart();

  /* ---------------- Newsletter-Rückmeldung ---------------- */
  $$("[data-news]").forEach(function (f) {
    if (window.location.search.indexOf("customer_posted=true") > -1) {
      var ok = $("[data-news-ok]", f);
      if (ok) ok.hidden = false;
    }
  });
})();

/* ---------------- Hero-Slider ---------------- */
(function () {
  "use strict";
  var sliders = [].slice.call(document.querySelectorAll("[data-hero-slider]"));
  sliders.forEach(function (root) {
    var track = root.querySelector("[data-hero-track]");
    if (!track) return;
    var slides = [].slice.call(track.children);
    if (slides.length < 2) return;
    var dots = [].slice.call(root.querySelectorAll("[data-hero-dot]"));
    var interval = Number(root.dataset.interval) || 5000;
    var autoplay = root.dataset.autoplay === "true";
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var index = 0, timer = null;

    function goTo(i) {
      index = (i + slides.length) % slides.length;
      track.scrollTo({ left: track.clientWidth * index, behavior: reduce ? "auto" : "smooth" });
      markDots();
    }
    function markDots() {
      dots.forEach(function (d, n) { d.classList.toggle("is-on", n === index); });
    }
    function start() {
      if (!autoplay || reduce) return;
      stop();
      timer = setInterval(function () { goTo(index + 1); }, interval);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    // Position beim Wischen mitlesen
    var scrollWait;
    track.addEventListener("scroll", function () {
      clearTimeout(scrollWait);
      scrollWait = setTimeout(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== index) { index = i; markDots(); }
      }, 90);
    }, { passive: true });

    dots.forEach(function (d) {
      d.addEventListener("click", function () { stop(); goTo(Number(d.dataset.heroDot)); start(); });
    });

    // Automatik pausieren, solange der Nutzer eingreift
    ["pointerdown", "touchstart"].forEach(function (ev) {
      track.addEventListener(ev, stop, { passive: true });
    });
    ["pointerup", "touchend", "mouseleave"].forEach(function (ev) {
      track.addEventListener(ev, start, { passive: true });
    });
    document.addEventListener("visibilitychange", function () {
      if (document.hidden) { stop(); } else { start(); }
    });

    // Breite bei Drehung des Geräts neu ausrichten
    var resizeWait;
    window.addEventListener("resize", function () {
      clearTimeout(resizeWait);
      resizeWait = setTimeout(function () {
        track.scrollTo({ left: track.clientWidth * index, behavior: "auto" });
      }, 150);
    });

    markDots();
    start();
  });
})();
/* Rechtsklick auf Bildern unterbinden */
document.addEventListener("contextmenu", function (e) {
  if (e.target.tagName === "IMG") e.preventDefault();
});
/* Nach dem Loslassen zurueck auf den Ursprung */
(function () {
  var SEL = ".card, .bundle, .xcard, .amb";
  document.addEventListener("touchstart", function () {
    var open = document.querySelectorAll(".fh-release");
    for (var i = 0; i < open.length; i++) open[i].classList.remove("fh-release");
  }, { passive: true, capture: true });
  document.addEventListener("touchend", function (e) {
    var el = e.target.closest ? e.target.closest(SEL) : null;
    if (el) el.classList.add("fh-release");
  }, { passive: true });
})();
/* Produktgalerie: mit dem Finger wischen */
(function () {
  var stages = document.querySelectorAll("[data-gallery] .gal__stage");
  for (var s = 0; s < stages.length; s++) {
    (function (stage) {
      var gal = stage.closest("[data-gallery]");
      if (!gal) return;
      var x0 = 0, y0 = 0, live = false;

      stage.addEventListener("touchstart", function (e) {
        if (e.touches.length !== 1) { live = false; return; }
        x0 = e.touches[0].clientX;
        y0 = e.touches[0].clientY;
        live = true;
      }, { passive: true });

      stage.addEventListener("touchend", function (e) {
        if (!live) return;
        live = false;
        var t = e.changedTouches[0];
        var dx = t.clientX - x0;
        var dy = t.clientY - y0;
        if (Math.abs(dx) < 45) return;
        if (Math.abs(dx) < Math.abs(dy) * 1.4) return;

        var thumbs = gal.querySelectorAll("[data-gal-thumb]");
        if (thumbs.length < 2) return;

        var cur = 0;
        for (var i = 0; i < thumbs.length; i++) {
          if (thumbs[i].classList.contains("is-on")) cur = i;
        }
        var next = dx < 0 ? cur + 1 : cur - 1;
        if (next < 0) next = thumbs.length - 1;
        if (next >= thumbs.length) next = 0;
        thumbs[next].click();
        var item = gal.querySelector('[data-gal-item="' + next + '"]');
        var v = item ? item.querySelector("video") : null;
        if (v) {
          v.muted = true;
          v.setAttribute("muted", "");
          v.setAttribute("playsinline", "");
          try { v.currentTime = 0; } catch (err) {}
          var p = v.play();
          if (p && p.catch) { p.catch(function () { setTimeout(function () { v.play(); }, 150); }); }
        }
      }, { passive: true });
    })(stages[s]);
  }
})();
/* Produktgalerie: dezente Pfeile */
(function () {
  var ARROW = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5 8 12l7 7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var stages = document.querySelectorAll("[data-gallery] .gal__stage");

  for (var s = 0; s < stages.length; s++) {
    (function (stage) {
      var gal = stage.closest("[data-gallery]");
      if (!gal) return;
      if (gal.querySelectorAll("[data-gal-thumb]").length < 2) return;
      if (stage.querySelector(".gal__nav")) return;

      function go(dir) {
        var list = gal.querySelectorAll("[data-gal-thumb]");
        var cur = 0;
        for (var i = 0; i < list.length; i++) {
          if (list[i].classList.contains("is-on")) cur = i;
        }
        var next = cur + dir;
        if (next < 0) next = list.length - 1;
        if (next >= list.length) next = 0;
        list[next].click();
        var item = gal.querySelector('[data-gal-item="' + next + '"]');
        var v = item ? item.querySelector("video") : null;
        if (v) {
          v.muted = true;
          v.setAttribute("muted", "");
          v.setAttribute("playsinline", "");
          try { v.currentTime = 0; } catch (err) {}
          var p = v.play();
          if (p && p.catch) { p.catch(function () { setTimeout(function () { v.play(); }, 150); }); }
        }
      }

      var prev = document.createElement("button");
      prev.type = "button";
      prev.className = "gal__nav gal__nav--prev";
      prev.setAttribute("aria-label", "Vorheriges Bild");
      prev.innerHTML = ARROW;
      prev.addEventListener("click", function () { go(-1); });

      var next = document.createElement("button");
      next.type = "button";
      next.className = "gal__nav gal__nav--next";
      next.setAttribute("aria-label", "Nächstes Bild");
      next.innerHTML = ARROW;
      next.style.transform = "translateY(-50%) rotate(180deg)";
      next.addEventListener("click", function () { go(1); });

      stage.appendChild(prev);
      stage.appendChild(next);
    })(stages[s]);
  }
})();
/* Produktgalerie: aktives Video immer abspielen */
(function () {
  var gals = document.querySelectorAll("[data-gallery]");
  if (!gals.length) return;
  var current = null;

  function sync() {
    for (var g = 0; g < gals.length; g++) {
      var items = gals[g].querySelectorAll("[data-gal-item]");
      for (var i = 0; i < items.length; i++) {
        var v = items[i].querySelector("video");
        if (!v) continue;
        if (items[i].classList.contains("is-on")) {
          if (current !== v) {
            current = v;
            v.muted = true;
            v.setAttribute("muted", "");
            v.setAttribute("playsinline", "");
            try { v.currentTime = 0; } catch (e) {}
          }
          if (v.paused) {
            var p = v.play();
            if (p && p.catch) { p.catch(function () {}); }
          }
        } else if (!v.paused) {
          v.pause();
        }
      }
    }
  }

  sync();
  setInterval(sync, 250);
  document.addEventListener("touchstart", sync, { passive: true });
})();
/* Rechtsklick und Download-Button bei Videos unterbinden */
document.addEventListener("contextmenu", function (e) {
  if (e.target.tagName === "VIDEO") e.preventDefault();
});
document.querySelectorAll("video").forEach(function (v) {
  v.setAttribute("controlsList", "nodownload noplaybackrate");
  v.setAttribute("disablePictureInPicture", "");
});
new MutationObserver(function () {
  document.querySelectorAll("video:not([controlsList])").forEach(function (v) {
    v.setAttribute("controlsList", "nodownload noplaybackrate");
    v.setAttribute("disablePictureInPicture", "");
  });
}).observe(document.body, { childList: true, subtree: true });
/* Warenkorb nach dem Hinzufuegen ueber die App oeffnen */
(function () {
  if (window.__fbCart2) return;
  window.__fbCart2 = true;

  var KEY = "fb_open_cart";

  function oeffnen() {
    var btn = document.querySelector("[data-cart-open]");
    if (btn) { btn.click(); return true; }
    var c = document.querySelector("[data-cart]");
    var v = document.querySelector("[data-veil]");
    if (c) { c.classList.add("is-on"); if (v) v.classList.add("is-on"); return true; }
    return false;
  }

  function merken() {
    try { sessionStorage.setItem(KEY, String(Date.now())); } catch (e) {}
    try { document.cookie = "fb_open_cart=1;path=/;max-age=30"; } catch (e) {}
  }

  function pruefen() {
    var da = false;
    try { da = !!sessionStorage.getItem(KEY); } catch (e) {}
    if (!da) da = document.cookie.indexOf("fb_open_cart=1") > -1;
    if (!da) return;
    try { sessionStorage.removeItem(KEY); } catch (e) {}
    document.cookie = "fb_open_cart=;path=/;max-age=0";

    var n = 0;
    var t = setInterval(function () {
      n++;
      if (oeffnen() || n > 30) clearInterval(t);
    }, 300);
  }
  document.addEventListener("click", function (e) {
    var el = e.target.closest && e.target.closest(
      ".rbr-bap-new-footer, [class*='rbr-'][role='button'], [class*='bundle'] button"
    );
    if (el) merken();
  }, true);

  pruefen();
  document.addEventListener("DOMContentLoaded", pruefen);
  window.addEventListener("pageshow", pruefen);
})();